import { evmFn, fn, pageOptsStore, pageStore } from '@packages/stores'
import { Pages } from '@packages/utils/enums'
import { type TTransactionItem, type TSendToPassportId } from '@packages/utils/types'
import { get } from 'svelte/store'
import { DEFAULT_LOADER_TITLE } from '@packages/utils/constants'
import { waitVideoEnded } from '@components/progress/ProgressVideo.service'
import { fetchTokenMetadata, getAddress } from '@src/passport/blockchain'
import { type TAirDrop } from '@src/utils/types'
import { configStore } from '@src/stores'

export const checkTransactionQuery = (params: { [k: string]: string; }): boolean => {
  const hasBasicKeys = ['contractAddress', 'amount', 'title'].every((key) =>
    Object.prototype.hasOwnProperty.call(params, key),
  )

  return hasBasicKeys && (Boolean(params.tokenId) || (Boolean(params.contentTokenId) && Boolean(params.licenseType)))
}

export const goToPayment = ({
  title,
  amount,
  tokenId,
  contractAddress: address,
  progressVideos,
  contentTokenId,
  licenseType
}: TTransactionItem) => {
  pageOptsStore.set({
    subtitle: title,
    ...(tokenId ? { tokens: [{ contractAddress: address, tokenId, amount }] } : { memberships: [{ contractAddress: address }] }),
    ...(contentTokenId ? { licenses: [{ contractAddress: address, contentTokenId, licenseType }]} : {}),
    loaderText: DEFAULT_LOADER_TITLE,
    progressVideos,
  })
  pageStore.set(Pages.PAYMENT)
}

export const goToSendTokens = ({ userAddress, amount }: TSendToPassportId) => {
  pageOptsStore.set({ to: userAddress, amount })
  pageStore.set(Pages.SEND_TOKENS)
}

export const processAirDrop = async (data: TAirDrop) => {
  const chainId = get(configStore).chainId
  if (data.chainId !== chainId) {
    throw new Error('Chain ID mismatch. Expected: ' + chainId + ', got: ' + data.chainId)
  }
  const metadata = await fetchTokenMetadata(data.contractAddress, String(data.tokenId));
  let tokenImage = metadata.image || ''
  const { requestAirDrop } = get(evmFn)
  try {
    pageOptsStore.set({ loaderText: `AirDropping Token: ${metadata.name}` || '...', progressVideos: data.progressVideos })
    pageStore.set(Pages.LOADER)
    const targetAddress = await getAddress()
    await requestAirDrop({ ...data, targetAddress })
    await waitVideoEnded()

    pageOptsStore.set({
      subtitle: `Your account has a new token: ${metadata.name}`,
      receipt: false,
      tokenImage,
    })
    pageStore.set(Pages.PAYMENT_RESULT)
  } catch (err) {
    pageOptsStore.set({ errorMessage: err.statusText })
    pageStore.set(Pages.ERROR)
  }
}

export const processRequestLoyaltyPoints = async ({
  eventId,
  contractAddress,
}: {
  eventId: number
  contractAddress: string
}) => {
  const { requestLoyaltyPoints } = get(fn)
  try {
    pageOptsStore.set({ loaderText: 'Issuing Loyalty points..', progressVideos: [] })
    pageStore.set(Pages.LOADER)

    if (requestLoyaltyPoints) await requestLoyaltyPoints(eventId, contractAddress)

    pageOptsStore.set({ subtitle: 'The request for loyalty points was successful!', description: '', receipt: false })
    pageStore.set(Pages.PAYMENT_RESULT)
  } catch (err) {
    pageOptsStore.set({ description: err.message, title: 'The request failed' })
    pageStore.set(Pages.ERROR)
  }
}
